import { render, staticRenderFns } from "./TemplateSearchBar.vue?vue&type=template&id=3f9c8ac4&"
import script from "./TemplateSearchBar.vue?vue&type=script&lang=ts&"
export * from "./TemplateSearchBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports